// @ts-check
import React, { useLayoutEffect, useMemo, useState } from 'react';
import { StudioFooter } from '@edx/frontend-component-footer';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Toast } from '@openedx/paragon';

import AlertMessage from '../generic/alert-message';
import Header from '../header';
import { TaxonomyContext } from './common/context';
import messages from './messages';
import CustomFooter from '../custom-footer/custom-footer';

const TaxonomyLayout = () => {
  const intl = useIntl();
  // Use `setToastMessage` to show the toast.
  const [toastMessage, setToastMessage] = useState(/** @type{null|string} */(null));
  // Use `setToastMessage` to show the alert.
  const [alertProps, setAlertProps] = useState(/** @type {null|import('./common/context').AlertProps} */(null));

  const context = useMemo(() => ({
    toastMessage, setToastMessage, alertProps, setAlertProps,
  }), []);

  useLayoutEffect(() => {
    const updateMinHeight = () => {
      const headerHeight = (/** @type {HTMLElement} */ (document.querySelector(".studio-header")))?.offsetHeight || 0;
      const footerHeight = (/** @type {HTMLElement} */ (document.querySelector("footer")))?.offsetHeight || 0;


      const mainContent = document.querySelector(".main-content");
      if (mainContent instanceof HTMLElement) {
        mainContent.style.minHeight = `calc(100vh - ${headerHeight + footerHeight}px)`;
      }
    };

    updateMinHeight();
    window.addEventListener("resize", updateMinHeight);

    return () => window.removeEventListener("resize", updateMinHeight);
  }, []);

  return (
    <TaxonomyContext.Provider value={context}>
      <div className="bg-light-400">
        <Header isHiddenMainMenu />
        <div className='main-content'>
          {alertProps && (
            <AlertMessage
              data-testid="taxonomy-alert"
              className="mb-0"
              dismissible
              closeLabel={intl.formatMessage(messages.taxonomyDismissLabel)}
              onClose={() => setAlertProps(null)}
              {...alertProps}
            />
          )}
          <Outlet />
        </div>
        {/* <StudioFooter /> */}
        <CustomFooter />
        {toastMessage && (
          <Toast
            show
            onClose={() => setToastMessage(null)}
            data-testid="taxonomy-toast"
          >
            {toastMessage}
          </Toast>
        )}
      </div>
      <ScrollRestoration />
    </TaxonomyContext.Provider>
  );
};

export default TaxonomyLayout;
